export default "__VITE_ASSET__UezKvxwE__"